import React, { useState, useEffect } from "react";
import styled from "styled-components";
import FormatProfile from "./about.profilecard";
import { fetchTeamMembers } from "../services/notionService";

import aboutus from "../images/aboutus/aboutus.png";
import tealwave from "../images/aboutus/teal-wave.svg";
import Company from "./company";
import googlelogo from "../images/googlelogo.png";
import mcklogo from "../images/aboutus/companylogos/mclogo.png";
import stripelogo from "../images/aboutus/companylogos/stripelogo.png";
import gslogo from "../images/aboutus/companylogos/gslogo.png";
import MSlogo from "../images/microsoftlogo.png";
import Shopifylogo from "../images/shopifylogo.png";
import dslogo from "../images/dslogo.png";
import cflogo from "../images/cloudfare.png";
import rbclogo from "../images/rbclogo.png";
import tdlogo from "../images/tdlogo.png";
import cpplogo from "../images/cpplogo.png";
import ciscologo from "../images/ciscologo.png";
import avanadelogo from "../images/avanadelogo.png";
import cibclogo from "../images/cibclogo.png";
import belllogo from "../images/belllogo.png";






const styledSection = styled.section`
  padding: 4rem 0 0 0;
`;

const AbtSection = () => {
  // State to store team members from Notion
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch team members when component mounts
  useEffect(() => {
    async function loadTeamMembers() {
      try {
        setLoading(true);
        const members = await fetchTeamMembers();
        setTeamMembers(members);
        setError(null);
      } catch (err) {
        console.error('Failed to load team members:', err);
        setError('Unable to load team members. Please try again later.');
      } finally {
        setLoading(false);
      }
    }

    loadTeamMembers();
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div style={{ height: "100%", display: "grid", margin: "0", overflow: "hidden" }}>
    <styledSection style={{ background: "#B3E2D4", paddingTop: "7%" }}>
      <div className="container">
        <div className="row reverse-col">
          <div className="col-lg-6 m-auto">
            <h1>About Us</h1>
            <br />
            <h4 style={{ lineHeight: "160%", fontFamily: "nunito" }}>
            At Women In Technology Society, we’re here to support you in your journey through the tech world, join our community today!
            </h4>
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-5 py-5">
            <img src={aboutus} alt="main pic" width="100%" />
          </div>
        </div>
      </div>
    </styledSection>
    <img src={tealwave} className="w-100 mb-5" style={{ marginTop: "-5px" }} alt="teal-wave" />

    <div className="container">
      <div style={{textAlign:'center'}}>
                <h2 style={{fontFamily:"Helvetica",fontStyle:'normal',lineHeight:'140%',color:'#402B2B'}}>
                    Meet the WITS Family
                </h2>
      </div>

      {/* Show loading message while fetching data */}
      {loading && (
        <div className="row" style={{display: "flex",justifyContent: "center", textAlign:'center', fontFamily: "nunito"}}>
          <div className="col-12 p-5">
            <p style={{fontSize: '1.2rem', color: '#402B2B'}}>Loading team members...</p>
          </div>
        </div>
      )}

      {/* Show error message if fetch failed */}
      {error && (
        <div className="row" style={{display: "flex",justifyContent: "center", textAlign:'center', fontFamily: "nunito"}}>
          <div className="col-12 p-5">
            <p style={{fontSize: '1.2rem', color: '#e57154'}}>{error}</p>
          </div>
        </div>
      )}

      {/* Show message if no team members found */}
      {!loading && !error && teamMembers.length === 0 && (
        <div className="row" style={{display: "flex",justifyContent: "center", textAlign:'center', fontFamily: "nunito"}}>
          <div className="col-12 p-5">
            <p style={{fontSize: '1.2rem', color: '#402B2B'}}>No team members found.</p>
          </div>
        </div>
      )}

      {/* Render grouped members by department */}
      {!loading && !error && teamMembers.map((group, groupIndex) => (
        <div key={groupIndex}>
          {/* Department Heading */}
          <div style={{textAlign:'center', marginTop: '3rem', marginBottom: '1rem'}}>
            <h3 style={{fontFamily:"Helvetica", fontWeight:'600', color:'#402B2B'}}>
              {group.department}
            </h3>
          </div>
          
          {/* Members in this department */}
          <div className="row" style={{display: "flex", justifyContent: "center", textAlign:'center', fontFamily: "nunito"}}>
            {group.members.map((member, index) => (
              <FormatProfile 
                key={index}
                name={member.name} 
                title={member.title} 
                link={member.link} 
                image={member.image}
              />
            ))}
          </div>
        </div>
      ))}

      
    </div>
    <styledSection>
    <section style={{ backgroundColor: "#F1EFE2", padding: "7% 0", marginTop: "5%" }}>
        <div>
          <div className="container">
            <div className="row">
            <div class="horizontal-center w-100 p-4 m-auto">
					<h2>Where We've Worked</h2>
				</div>		
            </div>
            <div className="row">
              {/*company cards*/}
              <Company link="https://careers.google.com/jobs" image={googlelogo} />
              <Company link="https://www.mckinsey.com" image={mcklogo} />
              <Company link="https://stripe.com/en-ca/jobs" image={stripelogo} />
              <Company link="https://www.goldmansachs.com/careers/" image={gslogo} />
              <Company link="https://careers.microsoft.com/us/en" image={MSlogo} />
              <Company link="https://www.shopify.ca/careers" image={Shopifylogo} />
              <Company link="https://www.docusign.ca/company/careers" image={dslogo} />
              <Company link="https://www.cloudflare.com/careers/" image={cflogo} />
              <Company link="https://jobs.rbc.com/ca/en" image={rbclogo} />
              <Company link="https://jobs.td.com/en-CA/" image={tdlogo} />
              <Company link="https://www.cppinvestments.com/careers" image={cpplogo} />
              <Company link="https://www.cisco.com/c/en/us/about/careers.html" image={ciscologo} />
              <Company link="https://www.avanade.com/en-ca/career" image={avanadelogo} />
              <Company link="https://www.cibc.com/en/about-cibc/careers.html" image={cibclogo} />
              <Company link="https://jobs.bce.ca/bell/" image={belllogo} />
             
            </div>
          </div>
        </div>
        </section>
      </styledSection>
    </div>

  );
};
export default AbtSection;